// Types
import type { TPatchDataClient } from '~/misc/patch/types';

// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerPatchUserResourceAdapter } from '~/modules/manager/models/patch/user-resource-adapter';

export class ManagerPatchDataClient
  extends AbstractDataClient<ManagerPatchUserResourceAdapter>
  implements TPatchDataClient
{
  constructor(companyId: number) {
    super(new ManagerPatchUserResourceAdapter(companyId));
  }
}
